import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";

const steps = [
  { num: "01", title: "Consult", desc: "We learn about your business, goals, and current tech landscape." },
  { num: "02", title: "Plan", desc: "A clear roadmap with timelines, priorities, and deliverables." },
  { num: "03", title: "Build", desc: "We develop, test, and deploy solutions tailored to your needs." },
  { num: "04", title: "Support", desc: "Ongoing maintenance, monitoring, and iterative improvements." },
];

const Process = () => {
  const headingRef = useScrollReveal();
  const stepsRef = useStaggerReveal(120);

  return (
    <section className="bg-card py-24 md:py-32">
      <div className="mx-auto max-w-[1320px] px-6">
        <div ref={headingRef} className="mx-auto max-w-2xl text-center" data-reveal>
          <h2
            className="text-3xl font-bold tracking-tight text-foreground md:text-4xl"
            style={{ textWrap: "balance" }}
          >
            How We Work
          </h2>
          <p className="mt-4 text-muted-foreground">
            A structured, transparent process from first call to long-term partnership.
          </p>
        </div>

        <div ref={stepsRef} className="relative mt-16 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Connector line (desktop) */}
          <div className="absolute left-0 right-0 top-[38px] hidden h-[1px] bg-border lg:block" />

          {steps.map((s) => (
            <div
              key={s.num}
              data-reveal="scale"
              className="relative flex flex-col items-center text-center"
            >
              <div className="relative z-10 mb-5 flex h-[76px] w-[76px] items-center justify-center rounded-full border-2 border-border bg-card text-xl font-bold text-primary shadow-sm">
                {s.num}
              </div>
              <h3 className="text-base font-semibold text-foreground">{s.title}</h3>
              <p className="mt-2 max-w-[240px] text-sm leading-relaxed text-muted-foreground">
                {s.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
